import { render, staticRenderFns } from "./delete_jd.vue?vue&type=template&id=5622026b&scoped=true&"
import script from "./delete_jd.vue?vue&type=script&lang=js&"
export * from "./delete_jd.vue?vue&type=script&lang=js&"
import style0 from "./delete_jd.vue?vue&type=style&index=0&id=5622026b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622026b",
  null
  
)

export default component.exports